import * as Sebrae from '@sebrae/react-core';
import * as React from 'react';
import { AppContext } from '../../components/shared/context';
import { v2, version } from '../../constants/endpoints';

export const useEmpresa = () => {
  const { backendGet, backendPost, backendPut, backendDelete } =
    Sebrae.useBackend();
  const { empresa } = React.useContext(AppContext);

  const salvarRegistro = React.useCallback(
    (data) => backendPost(`${version}/empresa`, data),
    [backendPost],
  );
  const alterarSaldo = React.useCallback(
    (data) => backendPut(`${version}/empresa/alterar`, data),
    [backendPut],
  );

  const buscarEmpresasUsuario = React.useCallback(
    () => backendGet('v2/empresa'),
    [backendGet],
  );

  const verificarSaldoEmpresa = React.useCallback(
    (emp) => {
      const endpointVersion = !emp?.id || emp?.isConvidado ? version : v2;
      const idEmpresa = emp?.isConvidado ? `${emp?.id}/convidado` : emp?.id;
      return backendGet(
        `${endpointVersion}/empresa/verificar-saldo/${
          emp?.id ? idEmpresa : emp?.cnpj
        }`,
      );
    },
    [backendGet],
  );

  const updateIconeCor = React.useCallback(
    (data) => backendPost(`${version}/empresa/salvar-icone-cor`, data),
    [backendPost],
  );

  const getEmpresaCpe = React.useCallback(
    (cnpj) => backendGet(`${version}/empresa/${cnpj}/cpe`),
    [backendGet],
  );

  const habilitaLancamentosMei = React.useCallback(
    (bool) =>
      backendPut(
        `${version}/empresa/habilitar-lancamentos-automaticos-mei/${empresa?.id}/?habilitar=${bool}`,
      ),
    [backendPut, empresa],
  );

  const habilitaRecebimentoEmail = React.useCallback(
    (bool) =>
      backendPut(
        `${version}/empresa/habilitar-recebimento-relatorio-email/${empresa?.id}/?habilitar=${bool}`,
      ),
    [backendPut, empresa],
  );

  const verificarPermissao = React.useCallback(
    (id) => backendGet(`${version}/empresa/permissao/${id}`),
    [backendGet],
  );

  const excluirPermissao = React.useCallback(
    (id) => backendDelete(`${version}/empresa/${id}/permissao`),
    [backendDelete],
  );

  const alterarNomeEmpresa = React.useCallback(
    (empresaId, params) =>
      backendPut(`${v2}/empresa/${empresaId}/apelido`, params),
    [backendPut],
  );

  return {
    alterarNomeEmpresa,
    alterarSaldo,
    buscarEmpresasUsuario,
    excluirPermissao,
    getEmpresaCpe,
    habilitaLancamentosMei,
    habilitaRecebimentoEmail,
    salvarRegistro,
    updateIconeCor,
    verificarSaldoEmpresa,
    verificarPermissao,
  };
};
